"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawEvent = void 0;
exports.createBox = createBox;
exports.createRegularPolygon = createRegularPolygon;
exports["default"] = void 0;

var _Circle = _interopRequireDefault(require("../geom/Circle.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Feature = _interopRequireDefault(require("../Feature.js"));

var _GeometryType = _interopRequireDefault(require("../geom/GeometryType.js"));

var _Property = _interopRequireDefault(require("./Property.js"));

var _LineString = _interopRequireDefault(require("../geom/LineString.js"));

var _MapBrowserEvent = _interopRequireDefault(require("../MapBrowserEvent.js"));

var _MapBrowserEventType = _interopRequireDefault(require("../MapBrowserEventType.js"));

var _MultiLineString = _interopRequireDefault(require("../geom/MultiLineString.js"));

var _MultiPoint = _interopRequireDefault(require("../geom/MultiPoint.js"));

var _MultiPolygon = _interopRequireDefault(require("../geom/MultiPolygon.js"));

var _Point = _interopRequireDefault(require("../geom/Point.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _Polygon = _interopRequireWildcard(require("../geom/Polygon.js"));

var _Vector = _interopRequireDefault(require("../layer/Vector.js"));

var _Vector2 = _interopRequireDefault(require("../source/Vector.js"));

var _functions = require("../functions.js");

var _condition = require("../events/condition.js");

var _extent = require("../extent.js");

var _Style = require("../style/Style.js");

var _proj = require("../proj.js");

var _coordinate = require("../coordinate.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Draw
 */


/**
 * @typedef {Object} Options
 * @property {import("../geom/GeometryType.js").default} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike} [style]
 * Style for sketch features.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 */

/**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */

/**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */

/**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */

/**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */

/**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */

/**
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 * @enum {string}
 */
var Mode = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  CIRCLE: 'Circle'
};
/**
 * @enum {string}
 */

var DrawEventType = {
  /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */
  DRAWSTART: 'drawstart',

  /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */
  DRAWEND: 'drawend',

  /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */
  DRAWABORT: 'drawabort'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Draw~Draw} instances are
 * instances of this type.
 */

var DrawEvent =
/** @class */
function (_super) {
  __extends(DrawEvent, _super);
  /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */


  function DrawEvent(type, feature) {
    var _this = _super.call(this, type) || this;
    /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */


    _this.feature = feature;
    return _this;
  }

  return DrawEvent;
}(_Event["default"]);

exports.DrawEvent = DrawEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */

/**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */
var Draw =
/** @class */
function (_super) {
  __extends(Draw, _super);
  /**
   * @param {Options} options Options.
   */


  function Draw(options) {
    var _this = this;

    var pointerOptions =
    /** @type {import("./Pointer.js").Options} */
    options;

    if (!pointerOptions.stopDown) {
      pointerOptions.stopDown = _functions.FALSE;
    }

    _this = _super.call(this, pointerOptions) || this;
    /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {DrawOnSignature<void>}
     */

    _this.un;
    /**
     * @type {boolean}
     * @private
     */

    _this.shouldHandle_ = false;
    /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */

    _this.downPx_ = null;
    /**
     * @type {?}
     * @private
     */

    _this.downTimeout_;
    /**
     * @type {number|undefined}
     * @private
     */

    _this.lastDragTime_;
    /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */

    _this.pointerType_;
    /**
     * @type {boolean}
     * @private
     */

    _this.freehand_ = false;
    /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */

    _this.source_ = options.source ? options.source : null;
    /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */

    _this.features_ = options.features ? options.features : null;
    /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */

    _this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
    /**
     * Geometry type.
     * @type {import("../geom/GeometryType.js").default}
     * @private
     */

    _this.type_ =
    /** @type {import("../geom/GeometryType.js").default} */
    options.type;
    /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */

    _this.mode_ = getMode(_this.type_);
    /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */

    _this.stopClick_ = !!options.stopClick;
    /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */

    _this.minPoints_ = options.minPoints ? options.minPoints : _this.mode_ === Mode.POLYGON ? 3 : 2;
    /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */

    _this.maxPoints_ = _this.mode_ === Mode.CIRCLE ? 2 : options.maxPoints ? options.maxPoints : Infinity;
    /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.finishCondition_ = options.finishCondition ? options.finishCondition : _functions.TRUE;
    var geometryFunction = options.geometryFunction;

    if (!geometryFunction) {
      var mode_1 = _this.mode_;

      if (mode_1 === Mode.CIRCLE) {
        /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */
        geometryFunction = function geometryFunction(coordinates, geometry, projection) {
          var circle = geometry ?
          /** @type {Circle} */
          geometry : new _Circle["default"]([NaN, NaN]);
          var center = (0, _proj.fromUserCoordinate)(coordinates[0], projection);
          var squaredLength = (0, _coordinate.squaredDistance)(center, (0, _proj.fromUserCoordinate)(coordinates[coordinates.length - 1], projection));
          circle.setCenterAndRadius(center, Math.sqrt(squaredLength));
          var userProjection = (0, _proj.getUserProjection)();

          if (userProjection) {
            circle.transform(projection, userProjection);
          }

          return circle;
        };
      } else {
        var Constructor_1;

        if (mode_1 === Mode.POINT) {
          Constructor_1 = _Point["default"];
        } else if (mode_1 === Mode.LINE_STRING) {
          Constructor_1 = _LineString["default"];
        } else if (mode_1 === Mode.POLYGON) {
          Constructor_1 = _Polygon["default"];
        }
        /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */


        geometryFunction = function geometryFunction(coordinates, geometry, projection) {
          if (geometry) {
            if (mode_1 === Mode.POLYGON) {
              if (coordinates[0].length) {
                // Add a closing coordinate to match the first
                geometry.setCoordinates([coordinates[0].concat([coordinates[0][0]])]);
              } else {
                geometry.setCoordinates([]);
              }
            } else {
              geometry.setCoordinates(coordinates);
            }
          } else {
            geometry = new Constructor_1(coordinates);
          }

          return geometry;
        };
      }
    }
    /**
     * @type {GeometryFunction}
     * @private
     */


    _this.geometryFunction_ = geometryFunction;
    /**
     * @type {number}
     * @private
     */

    _this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
    /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.finishCoordinate_ = null;
    /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */

    _this.sketchFeature_ = null;
    /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */

    _this.sketchPoint_ = null;
    /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */

    _this.sketchCoords_ = null;
    /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */

    _this.sketchLine_ = null;
    /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */

    _this.sketchLineCoords_ = null;
    /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */

    _this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
    /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */

    _this.overlay_ = new _Vector["default"]({
      source: new _Vector2["default"]({
        useSpatialIndex: false,
        wrapX: options.wrapX ? options.wrapX : false
      }),
      style: options.style ? options.style : getDefaultStyleFunction(),
      updateWhileInteracting: true
    });
    /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */

    _this.geometryName_ = options.geometryName;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.noModifierKeys;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.freehandCondition_;

    if (options.freehand) {
      _this.freehandCondition_ = _condition.always;
    } else {
      _this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : _condition.shiftKeyOnly;
    }

    _this.addChangeListener(_Property["default"].ACTIVE, _this.updateState_);

    return _this;
  }
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  Draw.prototype.setMap = function (map) {
    _super.prototype.setMap.call(this, map);

    this.updateState_();
  };
  /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */


  Draw.prototype.getOverlay = function () {
    return this.overlay_;
  };
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */


  Draw.prototype.handleEvent = function (event) {
    if (event.originalEvent.type === _EventType["default"].CONTEXTMENU) {
      // Avoid context menu for long taps when drawing on mobile
      event.originalEvent.preventDefault();
    }

    this.freehand_ = this.mode_ !== Mode.POINT && this.freehandCondition_(event);
    var move = event.type === _MapBrowserEventType["default"].POINTERMOVE;
    var pass = true;

    if (!this.freehand_ && this.lastDragTime_ && event.type === _MapBrowserEventType["default"].POINTERDRAG) {
      var now = Date.now();

      if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
        this.downPx_ = event.pixel;
        this.shouldHandle_ = !this.freehand_;
        move = true;
      } else {
        this.lastDragTime_ = undefined;
      }

      if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
        clearTimeout(this.downTimeout_);
        this.downTimeout_ = undefined;
      }
    }

    if (this.freehand_ && event.type === _MapBrowserEventType["default"].POINTERDRAG && this.sketchFeature_ !== null) {
      this.addToDrawing_(event.coordinate);
      pass = false;
    } else if (this.freehand_ && event.type === _MapBrowserEventType["default"].POINTERDOWN) {
      pass = false;
    } else if (move && this.getPointerCount() < 2) {
      pass = event.type === _MapBrowserEventType["default"].POINTERMOVE;

      if (pass && this.freehand_) {
        this.handlePointerMove_(event);

        if (this.shouldHandle_) {
          // Avoid page scrolling when freehand drawing on mobile
          event.originalEvent.preventDefault();
        }
      } else if (event.originalEvent.pointerType === 'mouse' || event.type === _MapBrowserEventType["default"].POINTERDRAG && this.downTimeout_ === undefined) {
        this.handlePointerMove_(event);
      }
    } else if (event.type === _MapBrowserEventType["default"].DBLCLICK) {
      pass = false;
    }

    return _super.prototype.handleEvent.call(this, event) && pass;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   */


  Draw.prototype.handleDownEvent = function (event) {
    this.shouldHandle_ = !this.freehand_;

    if (this.freehand_) {
      this.downPx_ = event.pixel;

      if (!this.finishCoordinate_) {
        this.startDrawing_(event.coordinate);
      }

      return true;
    } else if (this.condition_(event)) {
      this.lastDragTime_ = Date.now();
      this.downTimeout_ = setTimeout(function () {
        this.handlePointerMove_(new _MapBrowserEvent["default"](_MapBrowserEventType["default"].POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
      }.bind(this), this.dragVertexDelay_);
      this.downPx_ = event.pixel;
      return true;
    } else {
      this.lastDragTime_ = undefined;
      return false;
    }
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   */


  Draw.prototype.handleUpEvent = function (event) {
    var pass = true;

    if (this.getPointerCount() === 0) {
      if (this.downTimeout_) {
        clearTimeout(this.downTimeout_);
        this.downTimeout_ = undefined;
      }

      this.handlePointerMove_(event);

      if (this.shouldHandle_) {
        var startingToDraw = !this.finishCoordinate_;

        if (startingToDraw) {
          this.startDrawing_(event.coordinate);
        }

        if (!startingToDraw && this.freehand_) {
          this.finishDrawing();
        } else if (!this.freehand_ && (!startingToDraw || this.mode_ === Mode.POINT)) {
          if (this.atFinish_(event.pixel)) {
            if (this.finishCondition_(event)) {
              this.finishDrawing();
            }
          } else {
            this.addToDrawing_(event.coordinate);
          }
        }

        pass = false;
      } else if (this.freehand_) {
        this.abortDrawing();
      }
    }

    if (!pass && this.stopClick_) {
      event.preventDefault();
    }

    return pass;
  };
  /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default} event A move event.
   * @private
   */


  Draw.prototype.handlePointerMove_ = function (event) {
    this.pointerType_ = event.originalEvent.pointerType;

    if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
      var downPx = this.downPx_;
      var clickPx = event.pixel;
      var dx = downPx[0] - clickPx[0];
      var dy = downPx[1] - clickPx[1];
      var squaredDistance = dx * dx + dy * dy;
      this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;

      if (!this.shouldHandle_) {
        return;
      }
    }

    if (this.finishCoordinate_) {
      this.modifyDrawing_(event.coordinate);
    } else {
      this.createOrUpdateSketchPoint_(event.coordinate.slice());
    }
  };
  /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */


  Draw.prototype.atFinish_ = function (pixel) {
    var at = false;

    if (this.sketchFeature_) {
      var potentiallyDone = false;
      var potentiallyFinishCoordinates = [this.finishCoordinate_];
      var mode = this.mode_;

      if (mode === Mode.POINT) {
        at = true;
      } else if (mode === Mode.CIRCLE) {
        at = this.sketchCoords_.length === 2;
      } else if (mode === Mode.LINE_STRING) {
        potentiallyDone = this.sketchCoords_.length > this.minPoints_;
      } else if (mode === Mode.POLYGON) {
        var sketchCoords =
        /** @type {PolyCoordType} */
        this.sketchCoords_;
        potentiallyDone = sketchCoords[0].length > this.minPoints_;
        potentiallyFinishCoordinates = [sketchCoords[0][0], sketchCoords[0][sketchCoords[0].length - 2]];
      }

      if (potentiallyDone) {
        var map = this.getMap();

        for (var i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++) {
          var finishCoordinate = potentiallyFinishCoordinates[i];
          var finishPixel = map.getPixelFromCoordinate(finishCoordinate);
          var dx = pixel[0] - finishPixel[0];
          var dy = pixel[1] - finishPixel[1];
          var snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
          at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;

          if (at) {
            this.finishCoordinate_ = finishCoordinate;
            break;
          }
        }
      }
    }

    return at;
  };
  /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */


  Draw.prototype.createOrUpdateSketchPoint_ = function (coordinates) {
    if (!this.sketchPoint_) {
      this.sketchPoint_ = new _Feature["default"](new _Point["default"](coordinates));
      this.updateSketchFeatures_();
    } else {
      var sketchPointGeom = this.sketchPoint_.getGeometry();
      sketchPointGeom.setCoordinates(coordinates);
    }
  };
  /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */


  Draw.prototype.createOrUpdateCustomSketchLine_ = function (geometry) {
    if (!this.sketchLine_) {
      this.sketchLine_ = new _Feature["default"]();
    }

    var ring = geometry.getLinearRing(0);
    var sketchLineGeom = this.sketchLine_.getGeometry();

    if (!sketchLineGeom) {
      sketchLineGeom = new _LineString["default"](ring.getFlatCoordinates(), ring.getLayout());
      this.sketchLine_.setGeometry(sketchLineGeom);
    } else {
      sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
      sketchLineGeom.changed();
    }
  };
  /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */


  Draw.prototype.startDrawing_ = function (start) {
    var projection = this.getMap().getView().getProjection();
    this.finishCoordinate_ = start;

    if (this.mode_ === Mode.POINT) {
      this.sketchCoords_ = start.slice();
    } else if (this.mode_ === Mode.POLYGON) {
      this.sketchCoords_ = [[start.slice(), start.slice()]];
      this.sketchLineCoords_ = this.sketchCoords_[0];
    } else {
      this.sketchCoords_ = [start.slice(), start.slice()];
    }

    if (this.sketchLineCoords_) {
      this.sketchLine_ = new _Feature["default"](new _LineString["default"](this.sketchLineCoords_));
    }

    var geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
    this.sketchFeature_ = new _Feature["default"]();

    if (this.geometryName_) {
      this.sketchFeature_.setGeometryName(this.geometryName_);
    }

    this.sketchFeature_.setGeometry(geometry);
    this.updateSketchFeatures_();
    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
  };
  /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */


  Draw.prototype.modifyDrawing_ = function (coordinate) {
    var map = this.getMap();
    var geometry = this.sketchFeature_.getGeometry();
    var projection = map.getView().getProjection();
    var coordinates, last;

    if (this.mode_ === Mode.POINT) {
      last = this.sketchCoords_;
    } else if (this.mode_ === Mode.POLYGON) {
      coordinates =
      /** @type {PolyCoordType} */
      this.sketchCoords_[0];
      last = coordinates[coordinates.length - 1];

      if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) {
        // snap to finish
        coordinate = this.finishCoordinate_.slice();
      }
    } else {
      coordinates = this.sketchCoords_;
      last = coordinates[coordinates.length - 1];
    }

    last[0] = coordinate[0];
    last[1] = coordinate[1];
    this.geometryFunction_(
    /** @type {!LineCoordType} */
    this.sketchCoords_, geometry, projection);

    if (this.sketchPoint_) {
      var sketchPointGeom = this.sketchPoint_.getGeometry();
      sketchPointGeom.setCoordinates(coordinate);
    }

    if (geometry.getType() === _GeometryType["default"].POLYGON && this.mode_ !== Mode.POLYGON) {
      this.createOrUpdateCustomSketchLine_(
      /** @type {Polygon} */
      geometry);
    } else if (this.sketchLineCoords_) {
      var sketchLineGeom = this.sketchLine_.getGeometry();
      sketchLineGeom.setCoordinates(this.sketchLineCoords_);
    }

    this.updateSketchFeatures_();
  };
  /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @private
   */


  Draw.prototype.addToDrawing_ = function (coordinate) {
    var geometry = this.sketchFeature_.getGeometry();
    var projection = this.getMap().getView().getProjection();
    var done;
    var coordinates;
    var mode = this.mode_;

    if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
      this.finishCoordinate_ = coordinate.slice();
      coordinates =
      /** @type {LineCoordType} */
      this.sketchCoords_;

      if (coordinates.length >= this.maxPoints_) {
        if (this.freehand_) {
          coordinates.pop();
        } else {
          done = true;
        }
      }

      coordinates.push(coordinate.slice());
      this.geometryFunction_(coordinates, geometry, projection);
    } else if (mode === Mode.POLYGON) {
      coordinates =
      /** @type {PolyCoordType} */
      this.sketchCoords_[0];

      if (coordinates.length >= this.maxPoints_) {
        if (this.freehand_) {
          coordinates.pop();
        } else {
          done = true;
        }
      }

      coordinates.push(coordinate.slice());

      if (done) {
        this.finishCoordinate_ = coordinates[0];
      }

      this.geometryFunction_(this.sketchCoords_, geometry, projection);
    }

    this.createOrUpdateSketchPoint_(coordinate.slice());
    this.updateSketchFeatures_();

    if (done) {
      this.finishDrawing();
    }
  };
  /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */


  Draw.prototype.removeLastPoint = function () {
    if (!this.sketchFeature_) {
      return;
    }

    var geometry = this.sketchFeature_.getGeometry();
    var projection = this.getMap().getView().getProjection();
    var coordinates;
    var mode = this.mode_;

    if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
      coordinates =
      /** @type {LineCoordType} */
      this.sketchCoords_;
      coordinates.splice(-2, 1);

      if (coordinates.length >= 2) {
        this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
        var finishCoordinate = this.finishCoordinate_.slice();
        coordinates[coordinates.length - 1] = finishCoordinate;
        this.createOrUpdateSketchPoint_(finishCoordinate);
      }

      this.geometryFunction_(coordinates, geometry, projection);

      if (geometry.getType() === _GeometryType["default"].POLYGON && this.sketchLine_) {
        this.createOrUpdateCustomSketchLine_(
        /** @type {Polygon} */
        geometry);
      }
    } else if (mode === Mode.POLYGON) {
      coordinates =
      /** @type {PolyCoordType} */
      this.sketchCoords_[0];
      coordinates.splice(-2, 1);
      var sketchLineGeom = this.sketchLine_.getGeometry();

      if (coordinates.length >= 2) {
        var finishCoordinate = coordinates[coordinates.length - 2].slice();
        coordinates[coordinates.length - 1] = finishCoordinate;
        this.createOrUpdateSketchPoint_(finishCoordinate);
      }

      sketchLineGeom.setCoordinates(coordinates);
      this.geometryFunction_(this.sketchCoords_, geometry, projection);
    }

    if (coordinates.length === 1) {
      this.abortDrawing();
    }

    this.updateSketchFeatures_();
  };
  /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @api
   */


  Draw.prototype.finishDrawing = function () {
    var sketchFeature = this.abortDrawing_();

    if (!sketchFeature) {
      return;
    }

    var coordinates = this.sketchCoords_;
    var geometry = sketchFeature.getGeometry();
    var projection = this.getMap().getView().getProjection();

    if (this.mode_ === Mode.LINE_STRING) {
      // remove the redundant last point
      coordinates.pop();
      this.geometryFunction_(coordinates, geometry, projection);
    } else if (this.mode_ === Mode.POLYGON) {
      // remove the redundant last point in ring

      /** @type {PolyCoordType} */
      coordinates[0].pop();
      this.geometryFunction_(coordinates, geometry, projection);
      coordinates = geometry.getCoordinates();
    } // cast multi-part geometries


    if (this.type_ === _GeometryType["default"].MULTI_POINT) {
      sketchFeature.setGeometry(new _MultiPoint["default"]([
      /** @type {PointCoordType} */
      coordinates]));
    } else if (this.type_ === _GeometryType["default"].MULTI_LINE_STRING) {
      sketchFeature.setGeometry(new _MultiLineString["default"]([
      /** @type {LineCoordType} */
      coordinates]));
    } else if (this.type_ === _GeometryType["default"].MULTI_POLYGON) {
      sketchFeature.setGeometry(new _MultiPolygon["default"]([
      /** @type {PolyCoordType} */
      coordinates]));
    } // First dispatch event to allow full set up of feature


    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWEND, sketchFeature)); // Then insert feature

    if (this.features_) {
      this.features_.push(sketchFeature);
    }

    if (this.source_) {
      this.source_.addFeature(sketchFeature);
    }
  };
  /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */


  Draw.prototype.abortDrawing_ = function () {
    this.finishCoordinate_ = null;
    var sketchFeature = this.sketchFeature_;
    this.sketchFeature_ = null;
    this.sketchPoint_ = null;
    this.sketchLine_ = null;
    this.overlay_.getSource().clear(true);
    return sketchFeature;
  };
  /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */


  Draw.prototype.abortDrawing = function () {
    var sketchFeature = this.abortDrawing_();

    if (sketchFeature) {
      this.dispatchEvent(new DrawEvent(DrawEventType.DRAWABORT, sketchFeature));
    }
  };
  /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */


  Draw.prototype.appendCoordinates = function (coordinates) {
    var mode = this.mode_;
    var newDrawing = !this.sketchFeature_;

    if (newDrawing) {
      this.startDrawing_(coordinates[0]);
    }
    /** @type {LineCoordType} */


    var sketchCoords;

    if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
      sketchCoords =
      /** @type {LineCoordType} */
      this.sketchCoords_;
    } else if (mode === Mode.POLYGON) {
      sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ?
      /** @type {PolyCoordType} */
      this.sketchCoords_[0] : [];
    } else {
      return;
    }

    if (newDrawing) {
      sketchCoords.shift();
    } // Remove last coordinate from sketch drawing (this coordinate follows cursor position)


    sketchCoords.pop(); // Append coordinate list

    for (var i = 0; i < coordinates.length; i++) {
      this.addToDrawing_(coordinates[i]);
    }

    var ending = coordinates[coordinates.length - 1]; // Duplicate last coordinate for sketch drawing (cursor position)

    this.addToDrawing_(ending);
    this.modifyDrawing_(ending);
  };
  /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */


  Draw.prototype.extend = function (feature) {
    var geometry = feature.getGeometry();
    var lineString = geometry;
    this.sketchFeature_ = feature;
    this.sketchCoords_ = lineString.getCoordinates();
    var last = this.sketchCoords_[this.sketchCoords_.length - 1];
    this.finishCoordinate_ = last.slice();
    this.sketchCoords_.push(last.slice());
    this.sketchPoint_ = new _Feature["default"](new _Point["default"](last));
    this.updateSketchFeatures_();
    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
  };
  /**
   * Redraw the sketch features.
   * @private
   */


  Draw.prototype.updateSketchFeatures_ = function () {
    var sketchFeatures = [];

    if (this.sketchFeature_) {
      sketchFeatures.push(this.sketchFeature_);
    }

    if (this.sketchLine_) {
      sketchFeatures.push(this.sketchLine_);
    }

    if (this.sketchPoint_) {
      sketchFeatures.push(this.sketchPoint_);
    }

    var overlaySource = this.overlay_.getSource();
    overlaySource.clear(true);
    overlaySource.addFeatures(sketchFeatures);
  };
  /**
   * @private
   */


  Draw.prototype.updateState_ = function () {
    var map = this.getMap();
    var active = this.getActive();

    if (!map || !active) {
      this.abortDrawing();
    }

    this.overlay_.setMap(active ? map : null);
  };

  return Draw;
}(_Pointer["default"]);
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */


function getDefaultStyleFunction() {
  var styles = (0, _Style.createEditingStyle)();
  return function (feature, resolution) {
    return styles[feature.getGeometry().getType()];
  };
}
/**
 * Create a `geometryFunction` for `type: 'Circle'` that will create a regular
 * polygon with a user specified number of sides and start angle instead of a
 * {@link import("../geom/Circle.js").Circle} geometry.
 * @param {number} [opt_sides] Number of sides of the regular polygon.
 *     Default is 32.
 * @param {number} [opt_angle] Angle of the first point in counter-clockwise
 *     radians. 0 means East.
 *     Default is the angle defined by the heading from the center of the
 *     regular polygon to the current pointer position.
 * @return {GeometryFunction} Function that draws a polygon.
 * @api
 */


function createRegularPolygon(opt_sides, opt_angle) {
  return function (coordinates, opt_geometry, projection) {
    var center = (0, _proj.fromUserCoordinate)(
    /** @type {LineCoordType} */
    coordinates[0], projection);
    var end = (0, _proj.fromUserCoordinate)(
    /** @type {LineCoordType} */
    coordinates[coordinates.length - 1], projection);
    var radius = Math.sqrt((0, _coordinate.squaredDistance)(center, end));
    var geometry = opt_geometry ?
    /** @type {Polygon} */
    opt_geometry : (0, _Polygon.fromCircle)(new _Circle["default"](center), opt_sides);
    var angle = opt_angle;

    if (!opt_angle && opt_angle !== 0) {
      var x = end[0] - center[0];
      var y = end[1] - center[1];
      angle = Math.atan2(y, x);
    }

    (0, _Polygon.makeRegular)(geometry, center, radius, angle);
    var userProjection = (0, _proj.getUserProjection)();

    if (userProjection) {
      geometry.transform(projection, userProjection);
    }

    return geometry;
  };
}
/**
 * Create a `geometryFunction` that will create a box-shaped polygon (aligned
 * with the coordinate system axes).  Use this with the draw interaction and
 * `type: 'Circle'` to return a box instead of a circle geometry.
 * @return {GeometryFunction} Function that draws a box-shaped polygon.
 * @api
 */


function createBox() {
  return function (coordinates, opt_geometry, projection) {
    var extent = (0, _extent.boundingExtent)(
    /** @type {LineCoordType} */
    [coordinates[0], coordinates[coordinates.length - 1]].map(function (coordinate) {
      return (0, _proj.fromUserCoordinate)(coordinate, projection);
    }));
    var boxCoordinates = [[(0, _extent.getBottomLeft)(extent), (0, _extent.getBottomRight)(extent), (0, _extent.getTopRight)(extent), (0, _extent.getTopLeft)(extent), (0, _extent.getBottomLeft)(extent)]];
    var geometry = opt_geometry;

    if (geometry) {
      geometry.setCoordinates(boxCoordinates);
    } else {
      geometry = new _Polygon["default"](boxCoordinates);
    }

    var userProjection = (0, _proj.getUserProjection)();

    if (userProjection) {
      geometry.transform(projection, userProjection);
    }

    return geometry;
  };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/GeometryType.js").default} type Geometry type.
 * @return {Mode} Drawing mode.
 */


function getMode(type) {
  switch (type) {
    case _GeometryType["default"].POINT:
    case _GeometryType["default"].MULTI_POINT:
      return Mode.POINT;

    case _GeometryType["default"].LINE_STRING:
    case _GeometryType["default"].MULTI_LINE_STRING:
      return Mode.LINE_STRING;

    case _GeometryType["default"].POLYGON:
    case _GeometryType["default"].MULTI_POLYGON:
      return Mode.POLYGON;

    case _GeometryType["default"].CIRCLE:
      return Mode.CIRCLE;

    default:
      throw new Error('Invalid type: ' + type);
  }
}

var _default = Draw;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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